import {createI18n} from 'vue-i18n';
import en from "@/locales/en.json";
import sv from "@/locales/sv.json";

const numberFormats = {
  'sv': {
    currency: {
      style: 'currency',
      currency: 'SEK'
    },
    currency_without_fractions: {
      style: 'currency',
      currency: 'SEK',
      minimumFractionDigits: 0
    }
  },
  'en': {
    currency: {
      style: 'currency',
      currency: 'SEK'
    },
    currency_without_fractions: {
      style: 'currency',
      currency: 'SEK',
      minimumFractionDigits: 0
    }
  }
}
/*
function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  })
  return messages
}
*/
function getLocale() {
    const params = new URLSearchParams(window.location.search);
    return params.get("lang") || 'sv';
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  numberFormats,
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    sv,
    en,
  },
  //messages: loadLocaleMessages()
})
